import React from 'react';


export class LabeledInput extends React.Component {
    render() {
        const {
            color = 'main',
            label = '',
            value = '',
            placeholder = '',
            type = 'text',
            height = 'auto',
            dataAttribute = null,
            onChange = (event) => {},
            onKeyDown = (event) => {},
            onBlur = (event) => {}
        } = this.props;
        
        return (
            <label className="imd-form-label">
                <span className="imd-text-light-gray">{label}</span>
                <input
                    className={'imd-form-control imd-border-bottom-color-' + color + ' imd-text-' + color}
                    type={type}
                    style={{height: height}}
                    value={value}
                    placeholder={placeholder}
                    data-attribute={dataAttribute}
                    onChange={(event) => onChange(event)}
                    onKeyDown={(event) => onKeyDown(event)}
                    onBlur={(event) => onBlur(event)}
                />
            </label>
        );
    }
}
